import {Checkbox, CheckboxProps} from '@mui/material';
import {JSX} from 'react/jsx-runtime';
import {useState} from 'react';
import {t} from 'i18next';

const AurCheckbox = (props: JSX.IntrinsicAttributes & CheckboxProps) => {
  const [mouseEnter, setMouseEnter] = useState(false);

  const handleCellKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' && props.onChange) {
      event.preventDefault(); // Prevent form submission (if inside a form)

      // Toggle checked value
      const newChecked = !props.checked;

      props.onChange(
        {
          ...event,
          target: {...event.target, checked: newChecked},
        } as any,
        newChecked
      );
    }
  };

  return (
    <Checkbox
      {...props}
      className="aur-checkbox"
      tabIndex={0}
      onKeyDown={handleCellKeyDown}
      checkedIcon={
        <img
          aria-hidden="true"
          src={
            props.disabled
              ? '/assests/images/checked_checkbox_disabled.svg'
              : mouseEnter
                ? '/assests/images/checked_checkbox_hover.svg'
                : '/assests/images/checked_checkbox.svg'
          }
          alt={`${t('common.aurCheckbox.checkedChecbox')}`}
        />
      }
      onMouseEnter={() => setMouseEnter(true)}
      onMouseLeave={() => setMouseEnter(false)}
      indeterminateIcon={
        <img
          aria-hidden="true"
          src={
            mouseEnter
              ? '/assests/images/indeterminate_checkbox_hover.svg'
              : '/assests/images/indeterminate_checkbox.svg'
          }
          alt={`${t('common.aurCheckbox.indeterminateCheckbox')}`}
        />
      }
      disableFocusRipple
      focusVisibleClassName="aur-checkbox-focus-visible"
    />
  );
};

export default AurCheckbox;
